// import Layout from "@/layout"
import Layout from "@/layout/components/NestedView";
var MES = [{
  path: "orderManagement",
  redirect: "/mes/orderManagement/purchaseOrder",
  component: Layout,
  name: "OrderManagement",
  alwaysShow: true,
  meta: {
    title: "订单管理",
    icon: "user"
  },
  children: [{
    path: "productionProgress",
    component: function component() {
      return import("@/pages/mes/orderManagement/productionProgress");
    },
    name: "productionProgress",
    meta: {
      title: "生产订单跟进"
    }
  }, {
    path: "purchaseOrder",
    component: function component() {
      return import("@/pages/mes/orderManagement/purchaseOrder");
    },
    name: "PurchaseOrder",
    meta: {
      title: "采购接单"
    }
  }, {
    path: "productionMeansCheck",
    component: function component() {
      return import("@/pages/mes/orderManagement/productionMeansCheck/productionMeansCheck");
    },
    name: "ProductionMeansCheck",
    meta: {
      title: "生产核对资料"
    }
  }, {
    path: "orderInfoPrint",
    component: function component() {
      return import("@/pages/mes/orderManagement/orderInfoPrint/orderInfoPrintList");
    },
    name: "OrderInfoPrintList",
    meta: {
      title: "资料打印"
    }
  }, {
    path: "returnOrder",
    component: function component() {
      return import("@/pages/mes/orderManagement/returnOrder/returnOrderList");
    },
    name: "ReturnOrderList",
    meta: {
      title: "退货订单"
    }
  }]
}, {
  path: "produceManagement",
  redirect: "/mes/produceManagement/fabricPurchase",
  component: Layout,
  name: "ProduceManagement",
  alwaysShow: true,
  meta: {
    title: "生产管理",
    icon: "user"
  },
  children: [{
    path: "fabricPurchase",
    component: function component() {
      return import("@/pages/mes/produceManagement/fabricPurchase/fabricPurchase");
    },
    name: "FabricPurchase",
    meta: {
      title: "面料采购"
    }
  }, {
    path: "secondaryProcess",
    component: function component() {
      return import("@/pages/mes/produceManagement/secondaryProcess/secondaryProcess");
    },
    name: "SecondaryProcess",
    meta: {
      title: "二次工艺加工"
    }
  }, {
    path: "prenatalSampleProduction",
    component: function component() {
      return import("@/pages/mes/produceManagement/prenatalSampleProduction/prenatalSampleProduction");
    },
    name: "PrenatalSampleProduction",
    meta: {
      title: "产前样制作"
    }
  }, {
    path: "cuttingBed",
    component: function component() {
      return import("@/pages/mes/produceManagement/cuttingBed/cuttingBed");
    },
    name: "CuttingBed",
    meta: {
      title: "裁床"
    }
  }, {
    path: "qualityControlQuery",
    component: function component() {
      return import("@/pages/mes/produceManagement/qualityControlQuery/qualityControlQuery");
    },
    name: "QualityControlQuery",
    meta: {
      title: "QC查询"
    }
  }]
}, {
  path: "deliveryManagement",
  redirect: "/mes/deliveryManagement/waitForDelivery",
  component: Layout,
  name: "DeliveryManagement",
  alwaysShow: true,
  meta: {
    title: "发货管理",
    icon: "user"
  },
  children: [{
    path: "waitForDelivery",
    component: function component() {
      return import("@/pages/mes/deliveryManagement/waitForDelivery/waitingList");
    },
    name: "WaitingList",
    meta: {
      title: "待发货"
    }
  }, {
    path: "receiptInquire",
    component: function component() {
      return import("@/pages/mes/deliveryManagement/receiptInquire/receiptInquire");
    },
    name: "ReceiptInquire",
    meta: {
      title: "收货查询"
    }
  }]
}, {
  path: "pattenManager",
  redirect: "/mes/pattenManager/pattenManager",
  component: Layout,
  name: "PattenManager",
  alwaysShow: true,
  meta: {
    title: "打版管理",
    icon: "user"
  },
  children: [{
    path: "pattenManager",
    component: function component() {
      return import("@/pages/mes/pattenManager/pattenManager");
    },
    name: "PattenManager",
    meta: {
      title: "打版管理"
    }
  }]
}, {
  path: "supplierManagement",
  redirect: "/mes/supplierManagement/supplierManagement/supplierProfile/supplier",
  component: Layout,
  name: "SupplierManagement",
  alwaysShow: true,
  meta: {
    title: "供应商管理",
    icon: "user"
  },
  children: [{
    path: "supplierProfile",
    component: function component() {
      return import("@/pages/mes/supplierManagement/supplierProfile/supplier");
    },
    name: "SupplierManagement",
    meta: {
      title: "供应商档案"
    }
  }]
}, {
  path: "supplierInfor",
  redirect: "/mes/supplierInfor/manufacturerInfor",
  component: Layout,
  name: "SupplierInfor",
  alwaysShow: true,
  meta: {
    title: "供应商信息完善",
    icon: "user"
  },
  children: [{
    path: "manufacturerInfor",
    component: function component() {
      return import("@/pages/mes/supplierInfor/manufacturerInfor");
    },
    name: "ManufacturerInfor",
    meta: {
      title: "生产厂家能力信息完善"
    }
  }, {
    path: "distributorWholesaleInfor",
    component: function component() {
      return import("@/pages/mes/supplierInfor/distributorWholesaleInfor");
    },
    name: "DistributorWholesaleInfor",
    meta: {
      title: "经销批发信息完善"
    }
  }, {
    path: "paymentInfo",
    component: function component() {
      return import("@/pages/mes/supplierInfor/paymentInfo");
    },
    name: "PaymentInfo",
    meta: {
      title: "付款信息"
    }
  }]
}, {
  path: "reportManagement",
  redirect: "/mes/reportManagement/orderSynchronizationLog",
  component: Layout,
  name: "reportManagement",
  alwaysShow: true,
  meta: {
    title: "报表管理",
    icon: "user"
  },
  children: [{
    path: "orderSynchronizationLog",
    component: function component() {
      return import("@/pages/mes/reportManagement/orderSynchronizationLog");
    },
    name: "orderSynchronizationLog",
    meta: {
      title: "采购订单同步日志"
    }
  }]
}];
export default MES;